export default {
  defaultSectionTitle: '表单分区',
  checkFormErrors: '请检查表单中的错误',
  validation: {
    requiredSelect: '请选择{field}',
    requiredInput: '请输入{field}',
    requiredUpload: '请上传{field}',
    numberMin: '{label}不能小于{limit}',
    numberMax: '{label}不能大于{limit}',
    invalidFormat: '格式不正确',
    fallback: '校验未通过'
  },
  upload: {
    dragMain: '点击或拖拽文件到此处上传',
    dragSub: '请上传相关文件',
    uploadFailed: '文件上传失败'
  },
  apiDynamic: {
    loading: '加载选项中...',
    empty: '暂无选项',
    loadFailed: '选项加载失败',
    missingUrl: '未配置请求地址',
    retry: '重试'
  },
  placeholders: {
    containerSelect: '请选择箱型箱量',
    date: '请选择日期',
    containerDetail: '点击选择箱型箱量/货物明细',
    searchSelect: '搜索并选择{field}',
    customer: '请选择客户',
    vesselName: '请输入船名',
    voyageNo: '请输入航次',
    multiLine: '请输入'
  },
  recognition: {
    confidence: '识别置信度: {percent}%',
    confirmHint: '请确认'
  },
  modals: {
    customer: {
      title: '选择客户',
      searchPlaceholder: '搜索客户名称、联系人、联系电话',
      empty: '未找到匹配的客户'
    },
    container: {
      title: '选择箱型箱量',
      clearAll: '清空',
      quickFill: '快捷填充'
    }
  },
  containerSelect: {
    title: '选择箱型箱量',
    placeholder: '请选择箱型箱量',
    clear: '清空',
    quickFill: '快捷填充'
  },
  customerSelect: {
    title: '选择客户',
    placeholder: '请选择客户',
    searchPlaceholder: '搜索客户名称、联系人、联系电话',
    empty: '未找到匹配的客户',
    loadFailed: '加载客户列表失败',
    retry: '重试'
  },
  vesselVoyage: {
    vesselPlaceholder: '请输入船名',
    voyagePlaceholder: '请输入航次'
  },
  multiLine: {
    placeholder: '请输入',
    lineChars: 'L{line}: {count}字'
  },
  field: {
    confidenceTooltip: '识别置信度: {percent}%',
    confirmHint: '请确认',
    inputLabel: '请输入{label}',
    selectLabel: '请选择{label}',
    selectContainer: '请选择箱型箱量',
    selectDate: '请选择日期',
    selectStartDate: '开始时间',
    selectEndDate: '结束时间',
    selectCustomer: '请选择客户',
    cargoPlaceholder: '点击选择箱型箱量/货物明细',
    consigneePlaceholder: '搜索并选择{label}',
    uploadTip: '支持 PDF/JPG/PNG/DOC，最多 10 个文件',
    uploadMainText: '点击或拖拽文件到此处上传',
    uploadHint: '请上传相关文件',
    uploadFailed: '文件上传失败',
    uploadRequired: '请上传{label}',
    invalidFormat: '格式不正确'
  },
  validate: {
    validationFailed: '校验未通过'
  },
  renderer: {
    attachments: '附件',
    sectionDefault: '表单分区',
    showJson: '查看 JSON',
    hideJson: '隐藏 JSON',
    jsonPreviewTitle: 'businessFields 预览',
    copyJson: '复制 JSON',
    jsonCopied: 'JSON 已复制',
    validateFailed: '请检查表单中的错误',
    requiredField: '请输入{label}',
    addRow: '添加一行',
    removeRow: '删除此行',
    action: '操作',
    delete: '删除',
    noFields: '暂无字段',
    serviceTypeConfigEmpty: '请先在上方配置「服务类型」单选及其枚举选项',
    cargoInfoWithType: '{type}货物信息',
    addRowWithType: '添加{type}明细',
    serviceTypeFcl: '整箱',
    serviceTypeLcl: '拼箱',
    serviceTypeRoro: '滚装',
    serviceTypeBulk: '散杂货',
    serviceTypeDefault: '默认',
    sourceTag: '来源'
  },
  cargoSummary: {
    match: {
      singleType: '单种',
      pieces: '件数',
      perContainer: '每箱',
      perPallet: '单板',
      totalPieces: '总件数',
      totalWeight: '总毛重',
      totalVolume: '总体积',
      volume: '体积',
      oversized: '是否超限',
      stowageFactor: '积载因数',
      defaultCm: '默认CM',
      defaultUnitCm: '默认单位:CM',
      defaultUnitCmFw: '默认单位：CM',
      defaultM: '默认M',
      defaultUnitM: '默认单位:M',
      defaultUnitMFw: '默认单位：M'
    }
  },
  viewTemplate: {
    invalidTitle: '模板数据无效',
    invalidSubtitle: '视图模板数据缺失或格式错误。',
    notConfiguredTitle: '模板未配置',
    notConfiguredSubtitle: '当前视图模板未包含任何分区。',
    defaultTitle: '订单详情',
    noData: '暂无匹配的数据'
  },
  viewField: {
    noImage: '无图片'
  },
  feeDetail: {
    addRow: '新增费用行',
    itemCount: '共 {count} 项费用',
    selectContainerFirst: '请先在「箱型箱量」中选择箱型',
    clientReadonlyHint: '费用明细仅供查看，如有疑问请联系您的货代',
    emptyHint: '暂无费用明细，点击「新增费用行」添加',
    columns: {
      feeName: '费用名称',
      basis: '计费单位',
      currency: '币种',
      unitPriceContainer: '单价（按箱型）',
      unitPriceTicket: '单价（票）',
      remarks: '备注',
      perTicket: '按票',
      selectContainerType: '请先选择箱型',
      byContainer: '箱',
      byTicket: '票'
    },
    placeholders: {
      feeName: '费用名称',
      remarks: '费用说明'
    },
    actions: {
      restoreSource: '恢复该行来源值',
      deleteRow: '删除该行'
    }
  },
  vesselSchedule: {
    title: '选择船期（可跳过）',
    hint: '以下为运价支持的班期，选择后自动回填「船名航次 / ETD / ETA」。也可跳过，直接沿用已有的船名航次与船期。',
    transit: '航程',
    days: '天',
    selected: '已选',
    skipTitle: '暂不选择船期',
    skipSub: '沿用已有船名航次 / 船期',
    empty: '暂无可选船期',
    cancel: '取消',
    skip: '跳过，直接下单'
  },
  containerQty: {
    placeholder: '请选择箱型箱量',
    emptyPrompt: '暂无可选箱型，请先选择运价来源',
    unit: '箱'
  }
}
